import { useEffect, useState, type JSX } from 'react';

import { Checkbox, Col, Row, Space } from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { useMediaQuery } from 'react-responsive';
import { FilterBarConstant } from 'src/constants';
import { v4 as uuid } from 'uuid';

import { ScreenBreakpoint } from '../../../styles';
import { DropdownFilterButton } from '../DropdownFilterButton/DropdownFilterButton';

import * as Styles from './CheckboxFilter.styles';

interface CheckboxFilterProps {
  label: string | JSX.Element;
  groups: FilterBarConstant.GroupOption[];
  onSelect: (values: CheckboxValueType[]) => void;
  selectedValues?: CheckboxValueType[];
  testId?: string;
}

export const CheckboxFilter = ({ groups, onSelect, selectedValues = [], label, testId }: CheckboxFilterProps) => {
  const [values, setValues] = useState<CheckboxValueType[]>(selectedValues);
  const isMobile = useMediaQuery({ query: `(max-width: ${ScreenBreakpoint.mobile.max})` });

  const onChange = (checkedValues: CheckboxValueType[]) => {
    setValues(checkedValues);
    onSelect(checkedValues);
  };

  useEffect(() => {
    setValues(selectedValues);
  }, [selectedValues]);

  const renderOptions = (options: FilterBarConstant.GroupOptionItem[]) => (
    <Row gutter={[0, 4]}>
      {options.map((option: FilterBarConstant.GroupOptionItem) => (
        <Col key={uuid()} span={24}>
          <Checkbox
            value={option.value}
            className={Styles.checkboxWrapper}
            data-testid={`${testId}-${option.value.toLowerCase().replace(/ /g, '-')}`}>
            <span className={Styles.labelWrapper}>{option?.label}</span>
          </Checkbox>
        </Col>
      ))}
    </Row>
  );

  return (
    <DropdownFilterButton isDirty={selectedValues.length > 0} label={label} testId={testId + '-btn'}>
      <Checkbox.Group style={{ width: '100%' }} value={values} onChange={onChange}>
        {isMobile && (
          <Col span={24}>
            <div className={Styles.label}>{label}</div>
          </Col>
        )}
        <Space size={8} direction='vertical'>
          {groups.map((aGroup: FilterBarConstant.GroupOption, index: number) => (
            <Row key={aGroup.title ?? index} gutter={[0, 8]}>
              {groups?.length > 1 && (
                <Col
                  span={24}
                  className={Styles.labelWrapper}
                  data-testid={aGroup.title?.toLowerCase().replace(/ /g, '-')}>
                  {aGroup.title}
                </Col>
              )}
              {renderOptions(aGroup.options)}
            </Row>
          ))}
        </Space>
      </Checkbox.Group>
    </DropdownFilterButton>
  );
};
